import { ControlFacet } from '../models/controls/ControlFacet';

export const tilesLayoutControl = new ControlFacet<{
  itemKey: string | undefined;
}, {
    isAvailable: boolean;
  }>('tilesLayoutControl');